import createConfigureStore from './createConfigureStore';
import { reducersMap } from './rootReducerLogin';
import rootSaga from './rootSagaLogin';

export default createConfigureStore(reducersMap, rootSaga);
